export const decimalsCount = 6;
export const decimalsMultiplier = Math.pow(10, decimalsCount);

export const contractTransactionFees = 0.015;
export const minimumTransactionFees = 100_000;
export const contractDefaultCollateralRatio = 1.2;
export const contractMinCollateralRatio = 1.1;
export const contractMaxCollateralRatio = 1.5;

export const minimumClaimableStableTokenAmount = 0.01 * decimalsMultiplier;
